export const MODE = 'MODE';
export const STATUS = 'STATUS';
export const OPTIONS = 'OPTIONS';
export const OPTION = 'OPTION';
export const AUTOMATION = 'AUTOMATION';
export const LIST = 'LIST';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const RESET = 'RESET';
